// ------------------------------
// Rob's Aquatics – Gift Progress
// ------------------------------

// Reward tiers mapped to cart subtotal (in CENTS) + gift variant IDs.
// ⚠️ Make sure these variant IDs match your
// "Bonus Gift - Auto-Added Reward" product variants.
window.RA_REWARD_TIERS = [
  {
    minSubtotal: 10000,          // $100.00
    variantId: 52002976170273,   // "FREE $25 Bonus Fish"
  },
  {
    minSubtotal: 20000,          // $200.00
    variantId: 52002976203041,   // "FREE $40 Bonus Fish"
  },
  {
    minSubtotal: 40000,          // $400.00
    variantId: 52002976235809,   // "FREE $60 Bonus Fish"
  },
  {
    minSubtotal: 60000,          // $600.00
    variantId: 52002976301345,   // "FREE $100 Bonus Fish"
  }
];

(function () {
  var ROOT_ID = "ra-gift-progress-root";
  var RA_IS_UPDATING_REWARDS = false;

  // Fetch cart JSON from Shopify
  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function formatMoney(amount) {
    return "$" + amount.toFixed(2);
  }

  // UI thresholds (in dollars) used for the bar + messages
  var config = {
    thresholds: [
      { amount: 50, label: "Bonus Activated – Start earning rewards" },
      { amount: 100, label: "FREE $25 Bonus Fish" },
      { amount: 200, label: "FREE $40 Bonus Fish" },
      { amount: 400, label: "FREE $60 Bonus Fish" },
      { amount: 600, label: "FREE $100 Bonus Fish" },
      { amount: 1000, label: "FREE Shipping on this order" }
    ]
  };

  // Turn cart JSON into progress state for the bar
  function calculate(cart) {
    // Prefer items_subtotal_price, fallback to total_price.
    var subtotalCents = 0;

    if (cart && typeof cart.items_subtotal_price === "number") {
      subtotalCents = cart.items_subtotal_price;
    } else if (cart && typeof cart.total_price === "number") {
      subtotalCents = cart.total_price;
    }

    var total = subtotalCents / 100; // dollars

    if (!isFinite(total)) {
      total = 0;
    }

    var thresholds = config.thresholds;
    var reached = thresholds.filter(function (t) { return total >= t.amount; });
    var next = thresholds.find(function (t) { return total < t.amount; });

    var max = thresholds[thresholds.length - 1].amount;
    var percent = max > 0 ? Math.min(100, (total / max) * 100) : 0;

    return { total: total, thresholds: thresholds, reached: reached, next: next, percent: percent };
  }

  // Build HTML for the top bar
  function markup(state) {
    var top = formatMoney(state.total) + " cart total";

    var message;
    if (state.total === 0) {
      message = "Add fish to your cart to start unlocking bonuses.";
    } else if (state.next) {
      message =
        "Only " +
        formatMoney(state.next.amount - state.total) +
        " more to unlock: " +
        state.next.label;
    } else {
      message = "You unlocked ALL bonuses on this order! Monster haul!";
    }

    var tiers = state.thresholds
      .map(function (t) {
        var reachedClass = state.total >= t.amount ? "ra-gift-tier--reached" : "";
        return (
          '<div class="ra-gift-tier ' +
          reachedClass +
          '">' +
          '<div class="ra-gift-tier__dot"></div>' +
          "<div>" +
          formatMoney(t.amount) +
          " \u2013 " +
          t.label +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    return (
      '<div class="ra-gift-bar">' +
      '  <div class="ra-gift-bar__inner">' +
      '    <div class="ra-gift-bar__title">Bonus Rewards Progress</div>' +
      '    <div class="ra-gift-bar__topline">' + top + "</div>" +
      '    <div class="ra-gift-bar__message"><strong>' + message + "</strong></div>" +
      '    <div class="ra-gift-bar__progress-track">' +
      '      <div class="ra-gift-bar__progress-fill" style="width:' + state.percent + '%"></div>' +
      "    </div>" +
      '    <div class="ra-gift-bar__tiers">' + tiers + "</div>" +
      "  </div>" +
      "</div>"
    );
  }

  // Sync free gift variants with current subtotal
  function raHandleRewards(cart) {
    if (!window.RA_REWARD_TIERS || !Array.isArray(window.RA_REWARD_TIERS)) return;
    if (!cart || RA_IS_UPDATING_REWARDS) return;

    RA_IS_UPDATING_REWARDS = true;

    // Use subtotal (in cents) for qualifying thresholds
    var subtotal = 0;
    if (typeof cart.items_subtotal_price === "number") {
      subtotal = cart.items_subtotal_price;
    } else if (typeof cart.total_price === "number") {
      subtotal = cart.total_price;
    }

    var lineItems = cart.items || [];

    // Map of current quantities by variant ID
    var currentQtyByVariant = {};
    lineItems.forEach(function (item) {
      currentQtyByVariant[item.variant_id] = item.quantity;
    });

    // Which tiers are active at this subtotal
    var activeTierVariants = window.RA_REWARD_TIERS
      .filter(function (tier) {
        return subtotal >= tier.minSubtotal;
      })
      .map(function (tier) {
        return tier.variantId;
      });

    var updates = {};

    // Ensure active tier variants exist with qty 1
    activeTierVariants.forEach(function (variantId) {
      if (!currentQtyByVariant[variantId]) {
        updates[variantId] = 1;
      }
    });

    // Remove gift variants that are no longer active
    Object.keys(currentQtyByVariant).forEach(function (variantIdStr) {
      var variantId = parseInt(variantIdStr, 10);
      var isGiftVariant = window.RA_REWARD_TIERS.some(function (tier) {
        return tier.variantId === variantId;
      });
      if (!isGiftVariant) return;

      var shouldBeActive = activeTierVariants.indexOf(variantId) !== -1;
      if (!shouldBeActive) {
        updates[variantIdStr] = 0;
      }
    });

    // Nothing to change
    if (Object.keys(updates).length === 0) {
      RA_IS_UPDATING_REWARDS = false;
      return;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (updatedCart) {
        // Re-render bar with updated cart
        render(updatedCart);
      })
      .catch(function (err) {
        console.error("RA reward update error", err);
      })
      .finally(function () {
        RA_IS_UPDATING_REWARDS = false;
      });
  }

  // Render the bar; optional cart argument to reuse existing cart JSON
  function render(cart) {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    var cartPromise = cart ? Promise.resolve(cart) : fetchCart();

    cartPromise.then(function (cartData) {
      var state = calculate(cartData);
      root.innerHTML = markup(state);

      // After updating UI, make sure free gifts match this cart state
      raHandleRewards(cartData);
    });
  }

  // Initial render on page load
  document.addEventListener("DOMContentLoaded", function () {
    render();
  });

  // Force a fresh cart fetch whenever the theme dispatches cart:updated
  document.addEventListener("cart:updated", function () {
    fetchCart().then(function (cart) {
      render(cart);
    });
  });
})();